import { createStore } from "vuex";

export default createStore({
  state: {
    token: "",
  },
  getters: {
    gettoken(state) {
      return state.token;
    },
  },
  mutations: {
    settoken(state, token) {
      state.token = token;
    },
  },
  actions: {},
  modules: {},
});
